(function () {
  'use strict';
  document.body.classList.add('bv-luxury-active');
  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) { entry.target.classList.add('bv-revealed'); revealObserver.unobserve(entry.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  function initReveal() {
    document.querySelectorAll('.bv-reveal, .bv-reveal-left, .bv-reveal-right, .bv-reveal-scale')
      .forEach(function (el) { revealObserver.observe(el); });
  }
  function initHeaderScroll() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;
    window.addEventListener('scroll', function () {
      header.classList.toggle('bv-header-scrolled', window.scrollY > 70);
    }, { passive: true });
  }
  function initParallax() {
    var hero = document.querySelector('.bv-hero__bg img');
    if (!hero || window.matchMedia('(max-width: 749px)').matches) return;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () { hero.style.transform = 'translateY(' + (window.scrollY * 0.28) + 'px)'; ticking = false; });
        ticking = true;
      }
    }, { passive: true });
  }
  function initTilt() {
    if (window.matchMedia('(max-width: 989px)').matches) return;
    document.querySelectorAll('[data-bv-tilt]').forEach(function (el) {
      var intensity = parseFloat(el.dataset.bvTilt) || 7;
      el.addEventListener('mousemove', function (e) {
        var rect = el.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        el.style.transform = 'perspective(900px) rotateX(' + (-y * intensity) + 'deg) rotateY(' + (x * intensity) + 'deg) translateZ(8px)';
        el.style.transition = 'transform 0.05s ease';
      });
      el.addEventListener('mouseleave', function () {
        el.style.transform = 'perspective(900px) rotateX(0) rotateY(0) translateZ(0)';
        el.style.transition = 'transform 0.6s cubic-bezier(0.16,1,0.3,1)';
      });
    });
  }
  function initMouseDepth() {
    if (window.matchMedia('(max-width: 989px)').matches) return;
    document.querySelectorAll('[data-bv-depth]').forEach(function (container) {
      var layers = container.querySelectorAll('[data-bv-depth-layer]');
      container.addEventListener('mousemove', function (e) {
        var rect = container.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        layers.forEach(function (layer) {
          var d = parseFloat(layer.dataset.bvDepthLayer) || 1;
          layer.style.transform = 'translate3d(' + (x*d*18) + 'px,' + (y*d*18) + 'px,0)';
          layer.style.transition = 'transform 0.1s ease';
        });
      });
      container.addEventListener('mouseleave', function () {
        layers.forEach(function (l) { l.style.transform='translate3d(0,0,0)'; l.style.transition='transform 0.8s cubic-bezier(0.16,1,0.3,1)'; });
      });
    });
  }
  function initLoader() {
    var loader = document.getElementById('bv-loader');
    if (!loader) return;
    function hide() { loader.classList.add('bv-loader--hidden'); setTimeout(function () { if (loader.parentNode) loader.parentNode.removeChild(loader); }, 800); }
    if (document.readyState === 'complete') { setTimeout(hide, 600); }
    else { window.addEventListener('load', function () { setTimeout(hide, 600); }); }
  }
  window.BvCountdown = function (el, dateStr) {
    var target = new Date(dateStr);
    var dEl=el.querySelector('[data-countdown-days]'), hEl=el.querySelector('[data-countdown-hours]'), mEl=el.querySelector('[data-countdown-mins]'), sEl=el.querySelector('[data-countdown-secs]');
    function pad(n){return String(Math.floor(n)).padStart(2,'0');}
    function tick(){
      var diff=Math.max(target-Date.now(),0);
      if(dEl)dEl.textContent=pad(diff/86400000);
      if(hEl)hEl.textContent=pad((diff%86400000)/3600000);
      if(mEl)mEl.textContent=pad((diff%3600000)/60000);
      if(sEl)sEl.textContent=pad((diff%60000)/1000);
    }
    tick(); setInterval(tick,1000);
  };
  function boot() {
    initReveal(); initHeaderScroll(); initParallax(); initTilt(); initMouseDepth(); initLoader();
    document.addEventListener('shopify:section:load', function () { initReveal(); initTilt(); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
